<div class="login-layout">
  <app-dn-logo />
  <div class="login-container">
    <dn-login *ngIf="!displayVerification"
      [deviceId]="deviceId"
      [verificationId]="verificationId"
      (loginResponse)="loginResponse($event)" 
      (goToSignUp)="goToSignUp($event)" 
      (goToForgotPassword)="goToForgotPassword($event)"
      (loginClicked)="loginClicked($event)" />   

    <dn-verification *ngIf="displayVerification" 
     [email]="email"
     [verificationType]="verificationType"
     [verificationId]="verificationId"
     (resendEmailClick)="resendEmailClick($event)"
     (resendSuccess)="resendSuccess($event)"
     (resendFail)="resendFailed($event)"
     (goToLogin)="goToLogin($event)"
     />
  </div>

</div>
